<template>
  <div class="kui-combobox" :class='{"direction": !options.isVertical}' :ref="options.field">
    <span v-show="options.title" class="kui-combobox-title"
      :class="{'required-must':options.required}">{{titleName}}</span>
    <kui-validatebox ref='validator' :options='options'>
      <el-select v-model="value" :clearable="options.clearable || true" :multiple="options.multiple || false"
        :filterable='options.filterable || false' :remote='options.remote || false'
        :reserve-keyword='options.reserveKeyword ||  false' :placeholder="options.placeholder || '请选择'"
        :remote-method="remoteMethod" :loading="loading" :collapse-tags='options.collapseTags || true'
        slot="validatebox-content" ref="combobox" :disabled="disabled" :class='{"validate-must":!isPassValidate}'
        @blur="validate" @change='change'>
        <el-option v-for="item in data" :key="item.dict_val" :label="item.dict_des" :value="item.dict_val"
          :disabled="item.disabled">
        </el-option>
      </el-select>
    </kui-validatebox>
  </div>
</template>
<script>
import combobox from "./src/combobox";
export default combobox;
</script>
<style lang='less' scoped>
.kui-combobox {
  align-items: center;
  padding: 8px;
  &.direction {
    display: inline-flex;
  }
  .kui-combobox-title {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #343434;
    padding: 0 5px 0 0;
    box-sizing: border-box;
    position: relative;
  }
  .kui-combobox-title.required-must:before {
    content: "*";
    color: #f56c6c;
    display: inline-block;
    position: absolute;
    line-height: 110%;
    left: -10px;
  }
  .el-select {
    width: 100%;
    &.validate-must {
      border-color: #f56c6c;
      :hover {
        border-color: #f56c6c;
      }
    }
    .el-select__tags {
      width: 100%;
      max-width: auto;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/combobox/index.vue